<template>
  <div class="sca-simple-editor">
    <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
      <div class="menu">
        <div :class="[{ 'is-active': isActive.bold() }, 'menu-option']" @click="commands.bold">
          <b-icon-type-bold/>
        </div>
        <div :class="[{ 'is-active': isActive.italic() }, 'menu-option']" @click="commands.italic">
          <b-icon-type-italic/>
        </div>
        <div :class="[{ 'is-active': isActive.underline() }, 'menu-option']" @click="commands.underline">
          <b-icon-type-underline/>
        </div>
        <div :class="[{ 'is-active': isActive.strike() }, 'menu-option']" @click="commands.strike">
          <b-icon-type-strikethrough/>
        </div>
        <div class="hidden flex-row gap-2">
          <div class="rotate-45" @click="commands.undo">
            <b-icon-arrow-90deg-left/>
          </div>
          <div class="rotate-45" @click="commands.redo">
            <b-icon-arrow-90deg-right/>
          </div>
        </div>
        <div :class="[{ 'is-active': isActive.bullet_list() }, 'menu-option']" @click="commands.bullet_list">
          <b-icon-list-ul/>
        </div>
      </div>
    </editor-menu-bar>
    <editor-content :value="value" class="simple-editor simple-content" :editor="editor"/>
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import { Bold, BulletList, ListItem, History, Italic, Strike, Underline, Link } from 'tiptap-extensions'
import {
  BIconArrow90degLeft,
  BIconArrow90degRight,
  BIconTypeStrikethrough,
  BIconTypeBold,
  BIconTypeItalic,
  BIconTypeUnderline,
  BIconListUl
} from 'bootstrap-vue'
import { debounce } from 'lodash'

export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  components: {
    EditorContent,
    EditorMenuBar,
    BIconArrow90degLeft,
    BIconArrow90degRight,
    BIconTypeStrikethrough,
    BIconTypeBold,
    BIconTypeItalic,
    BIconTypeUnderline,
    BIconListUl
  },
  data() {
    return {
      editor: null,
    }
  },
  methods: {
    clearEditor(){
      this.editor.clearContent()
    },
    updateContent() {
      if (this.editor && this.value !== this.editor.getHTML()) {
        this.editor.setContent(this.value, false)
      }
    }
  },
  beforeMount() {
    this.editor = new Editor({
      content: this.value || '',
      extensions: [
        new Bold(),
        new BulletList(),
        new ListItem(),
        new History(),
        new Italic(),
        new Strike(),
        new Underline(),
        new Link()
      ]
    })

    this.editor.on('update', this.updateEditor)
  },
  mounted() {
    // Garantir que o conteúdo seja definido após o mount
    this.$nextTick(() => {
      this.updateContent()
    })
  },
  beforeUnmount() {
    if (this.editor) {
      this.editor.destroy()
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.updateContent()
      },
      immediate: false
    }
  },
  setup(props, context) {
    const updateEditor = debounce((editorInstance) => {
      context.emit('input', editorInstance.getHTML())
    }, 800)

    return {
      updateEditor
    }
  }
}
</script>

<style lang="scss">
  @import 'src/assets/scss/simple-content.scss';

  .sca-simple-editor {
    @apply bg-white;
    @apply border rounded border-grey border-solid shadow-drop;

    & .menu {
      // Container style
      @apply flex flex-row gap-2;
      // Menu Borders
      @apply border-grey border-t-0 border-b border-solid border-r-0 border-l-0 py-1 px-2;

      & .menu-option {
        @apply shadow-drop p-1 rounded select-none cursor-pointer;
      }

      & .menu-option.is-active {
        @apply bg-black text-white;
      }
    }

    & .simple-content {
      @apply px-2 ml-0 pt-2 h-full mb-1;

      min-height: 100px;
      max-height: 200px;
      @apply overflow-y-scroll overflow-x-hidden;

      & .ProseMirror {
        min-height: 100px;
        max-height: 200px;
      }
    }
  }
</style>
